<style>
    .ag-theme-material .ag-cell {
        line-height: 35px !important;
    }
</style>

<template>
  <div id="ag-grid-demo">
    <vx-card class="p-4 mb-6">
        <div class="flex flex-wrap items-center justify-between mb-10">
            <div class="flex items-center">
                <h4 style="margin-left: 10px">POD</h4>
            </div>
            <div class="flex items-center">
                <vs-button
                    class="mb-4 mr-1 btn md:mb-0"
                    @click="refreshData"
                    icon="refresh"
                >Refresh</vs-button>
                <vs-button
                    class="mb-4 mr-1 md:mb-0"
                    icon="filter_list"
                    @click="filterInit"
                >Filter</vs-button>
                <vs-button
                    class="mb-4 mr-1 md:mb-0"
                    icon="import_export"
                    @click="exportExcel({ endpoint: 'transport/pod/export', filter: filter, name: 'export_report_pod' })"
                >Export</vs-button>
                <vs-button
                    class="mb-4 mr-1 md:mb-0"
                    icon="import_export"
                    @click="filterGetPod"
                >Get POD</vs-button>
            </div>
        </div>
        <div class="mt-10">
            <vs-table :data="manifest" hoverFlat class="mt-5">
                <template slot="thead">
                    <vs-th style="min-width: 200px;">Reference</vs-th>
                    <vs-th style="min-width: 120px;">Schedule Date</vs-th>
                    <vs-th style="min-width: 120px;">Origin</vs-th>
                    <vs-th style="min-width: 120px;">Destination</vs-th>
                    <vs-th style="min-width: 80px; width: 120px">POD Status</vs-th>
                    <vs-th style="min-width: 120px; width: 120px">POD Date</vs-th>
                    <vs-th style="min-width: 120px; width: 120px">Receiver Name</vs-th>
                    <vs-th style="min-width: 80px; width: 120px">POD Remark</vs-th>
                    <vs-th style="min-width: 80px; width: 120px">Transporter</vs-th>
                    <vs-th style="min-width: 80px; width: 120px">POD Attachment</vs-th>
                    <vs-th style="min-width: 80px; width: 120px">POD e-Sign</vs-th>
                </template>
                <template slot-scope="{data}">
                    <vs-tr :data="detail" :key="index" v-for="(detail, index) in data">
                        <vs-td>
                            {{ detail.transport_reference }}
                        </vs-td>
                        <vs-td>
                            {{ detail.schedule_date }}
                        </vs-td>
                        <vs-td>
                            {{ detail.origin_name }}
                        </vs-td>
                        <vs-td>
                            {{ detail.destination_name }}
                        </vs-td>
                        <vs-td>
                            {{ detail.pod_name }}
                        </vs-td>
                        <vs-td>
                            {{ detail.pod_time }}
                        </vs-td>
                        <vs-td>
                            {{ detail.receiver_name }}
                        </vs-td>
                        <vs-td>
                            {{ detail.pod_remark }}
                        </vs-td>
                        <vs-td>
                            {{ detail.transporter_name }}
                        </vs-td>
                        <vs-td :data="detail.pod_file">
                            <vs-button v-if="detail.pod_file" class="mr-1" icon="attachment" size="small" @click="viewAttachment(detail.pod_file)">{{ detail.pod_file }}</vs-button>
                            <div v-if="!detail.pod_file">
                            </div>
                        </vs-td>
                        <vs-td :data="detail.pod_sign">
                            <vs-button v-if="detail.pod_sign" class="mr-1" icon="attachment" size="small" @click="viewAttachment(detail.pod_sign)">{{ detail.pod_sign }}</vs-button>
                            <div v-if="!detail.pod_sign">
                            </div>
                        </vs-td>
                    </vs-tr>
                </template>
            </vs-table>
        </div>
        <p class="text-right"><b>Showing {{ dataFrom }} to {{ dataTo }} of {{ dataTotal }}  total entries</b></p>
        <vs-pagination :total="totalPage" v-model="currentPage" :max="7"></vs-pagination>
        <!-- start-filter -->
        <vs-prompt @accept="fetchData" title="Filter" :active.sync="showFilter">
            <div class="con-exemple-prompt">

                <vs-input v-model="filter.outbound_reference" class="w-full mb-2" label="Outbound Reference" />

                <label class="vs-input--label">Schedule Date</label>
                <vs-row vs-w="12" vs-justify="space-between" class="mb-2">
                    <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="5" style="padding-left: 0">
                        <flat-pickr class="w-full p-2 vx-col" v-model="filter.schedule_date_start" />
                    </vs-col>
                    <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="2">To</vs-col>
                    <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="5" style="padding-right: 0">
                        <flat-pickr class="w-full p-2 vx-col" v-model="filter.schedule_date_end" />
                    </vs-col>
                </vs-row>

                <label class="vs-input--label">POD Date</label>
                <vs-row vs-w="12" vs-justify="space-between" class="mb-2">
                    <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="5" style="padding-left: 0">
                        <flat-pickr class="w-full p-2 vx-col" v-model="filter.pod_date" />
                    </vs-col>
                </vs-row>

                <label class="vs-input--label">Status POD</label>
                <vs-select
                    class="mb-2 selectExample"
                    v-model="filter.pod_code_id"
                    width="100%"
                    autocomplete
                    @input-change="searchDropdown($event, ddl_podcodes)"
                >
                    <vs-select-item v-for="(item, index) in ddl_podcodes.data" :key="index" :value="item.id" :text="item.name"/>
                </vs-select>

                <label class="vs-input--label">Transporter ID</label>
                <vs-select
                    class="mb-2 selectExample"
                    v-model="filter.transporter_id"
                    width="100%"
                    autocomplete
                    @input-change="searchDropdown($event, ddl_transporter)"
                >
                    <vs-select-item v-for="(item, index) in ddl_transporter.data" :key="index" :value="item.id" :text="item.transporter_code"/>
                </vs-select>

                <label class="vs-input--label">Origin ID</label>
                <vs-select
                    class="mb-2 selectExample"
                    v-model="filter.origin_id"
                    width="100%"
                    autocomplete
                    @input-change="searchDropdown($event, ddl_origin)"
                >
                    <vs-select-item v-for="(item, index) in ddl_origin.data" :key="index" :value="item.id" :text="item.village"/>
                </vs-select>

                <label class="vs-input--label">Destination ID</label>
                <vs-select
                    class="mb-2 selectExample"
                    v-model="filter.destination_id"
                    width="100%"
                    autocomplete
                    @input-change="searchDropdown($event, ddl_destination)"
                >
                    <vs-select-item v-for="(item, index) in ddl_destination.data" :key="index" :value="item.id" :text="item.village"/>
                </vs-select>

            </div>
        </vs-prompt>

        <vs-popup :title="'Attachment'" :active.sync="showPopupAttachment" id="myAttachpoppup">
            <div class="px-4 pt-4 pb-4 row">
            <div class="pt-5 vx-row">
                <img v-if="attach_name" :src="'https://wmsapi.goodang.com/upload/pod/'+attach_name" width="400px"/>
            </div>
                <vs-popup title="Close without Save ?" :active.sync="closePopupAttachment">
                    <p></p>
                </vs-popup>

            </div>
        </vs-popup>

        <vs-prompt @accept="getDataPod" title="Get POD" :active.sync="showGetPod">
            <div class="con-exemple-prompt">

                <label class="vs-input--label">POD Date</label>
                <vs-row vs-w="12" vs-justify="space-between" class="mb-2">
                    <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="12" style="padding-left: 0">
                        <flat-pickr class="w-full p-2 vx-col" v-model="filter_get_pod.date" />
                    </vs-col>
                </vs-row>

            </div>
        </vs-prompt>
    <!-- end-filter -->
    </vx-card>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue"
import '@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';

import { saveAs } from "file-saver";

export default {
    components: {
        vSelect,
        AgGridVue,
        flatPickr,
    },
    data() {
        return {
            gridOptions: {},
            maxPageNumbers: 7,
            gridApi: null,
            columnDefs: null,
            defaultColDef: {
                sortable: true,
                editable: false,
                resizable: true,
                suppressMenu: true
            },
            isLoading: false,
            maxRetry: 10,
            totalPage: 0,
            currentPage: 1,
            dataFrom: 0,
            dataTo: 0,
            dataTotal: 0,
            manifest: [],
            filter: {
                outbound_reference: "",
                pod_date: null,
                transporter_id: null,
                origin_id: null,
                destination_id: null,
                pod_code_id:null,
                schedule_date_start: null,
                schedule_date_end: null,
            },
            filter_get_pod: {
                date: null,
            },
            selectedId: null,
            showFilter: false,
            ddl_transporter: {
                data: [],
                loading: false,
                endpoint: 'master/transporters',
                objectKey: 'transporter_code'
            },
            ddl_vehicle: {
                data: [],
                loading: false,
                endpoint: 'master/vehicle',
                objectKey: 'vehicle_code'
            },
            ddl_podcodes: {
                data: [],
                loading: false,
                endpoint: 'master/podcodes',
                objectKey: 'pod_code'
            },
            ddl_origin: {
                data: [],
                loading: false,
                endpoint: 'master/areas',
                objectKey: 'village'
            },
            ddl_destination: {
                data: [],
                loading: false,
                endpoint: 'master/areas',
                objectKey: 'village'
            },
            ddl_customer: {
                data: [],
                loading: false,
                endpoint: 'master/customers',
                objectKey: 'name'
            },
            attach_name:'',
            showPopupAttachment:false,
            showGetPod: false,
        }
    },
    watch: {
        isLoading: function(){
            if(this.isLoading){
                this.$vs.loading()
            }
            else{
                this.$vs.loading.close()
            }
        },
        currentPage() {
            this.fetchData()
        },
    },
    methods: {
        fetchData() {
            this.isLoading = true
            //this.setFilter(this.filter);

            Promise.all([this.$http.post('transport/pod/get_pod?page=' + this.currentPage, this.filter), this.$http.post('unlock_all')])
            .then(this.$http.spread((resp, unlock) => {
                this.manifest = resp.data.data
                this.totalPage = resp.data.last_page;
                this.dataTotal = resp.data.total;
                this.dataFrom = resp.data.from;
                this.dataTo = resp.data.to;
                this.isLoading = false
            }))
            .catch(resp => {
                this.isLoading = false
                this.$vs.dialog({
                    type: 'confirm',
                    color: 'danger',
                    title: 'Server Error',
                    text: 'Try again?',
                    accept: () => {
                        this.refreshData()
                    },
                    acceptText: 'Yes',
                    cancelText: 'No'
                });
                return;
            })
        },
        viewData() {
            this.$router.push({
                name: 'pod-view',
                params: {
                    id: this.selectedId
                }
            })
        },
        refreshData() {
            this.maxRetry = 10
            this.fetchData()
        },
        onSelectionChanged() {
            var selectedRows = this.gridApi.getSelectedRows()
            var selectedRowsString = ''
            selectedRows.forEach(function(selectedRow, index) {
                if (index !== 0) {
                selectedRowsString += ', '
                }
                selectedRowsString += selectedRow.id
            })
            this.selectedId = selectedRowsString
            console.log(this.selectedId);
        },
        filterInit() {
            if(!this.masterSync){

                this.$http.all([
                this.$http.post("master/areas"),
                this.$http.post("master/transporters"),
                this.$http.post("master/podcodes"),
                ])
                .then(
                    this.$http.spread(
                        (
                    areas,
                    transporters,
                    podcodes,
                    ) => {
                        this.ddl_origin.data = areas.data.data;
                        this.ddl_destination.data = areas.data.data;
                        this.ddl_transporter = transporters.data;
                        this.ddl_podcodes.data = podcodes.data.data;

                        this.ddl_origin.data.unshift({
                            id: null,
                            village: 'Any'
                        })
                        this.ddl_destination.data.unshift({
                            id: null,
                            village: 'Any'
                        })
                        this.ddl_transporter.data.unshift({
                            id: null,
                            transporter_code: 'Any'
                        })
                        this.ddl_podcodes.data.unshift({
                            id: null,
                            pod_code: 'Any'
                        })
                        this.masterSync = true ;
                        setTimeout(() => {
                            this.showFilter = true;
                        }, 500);
                    }
                )
                )
                .catch((error) => {
                    this.isLoading = false;
                    this.masterSync = false ;
                    console.log(error)
                });
            }else{
                setTimeout(() => {
                    this.showFilter = true;
                }, 500);
            }
        },
        viewAttachment(attch){
            this.isLoading = false ;
            this.showPopupAttachment = true ;
            this.attach_name=attch;
        },
        filterGetPod() {
            this.showGetPod = true;
        },
        getDataPod() {
            this.isLoading = true

            this.$http.post('transport/pod/update_courier_pod_status', this.filter_get_pod ).then((resp) => {
                console.log(resp);
                this.isLoading = false

                this.fetchData();
            })
            .catch((resp) =>{
                console.log(resp.response);
                this.isLoading = false

                this.$vs.notify({
                    color: "danger",
                    title: "POD",
                    text: "Get POD Failed"
                });
            });
        },
    },
    mounted() {
        // this.gridApi = this.gridOptions.api;
        this.fetchData()
    },
    beforeMount() {
    }
}

</script>
